// @flow
import React from "react";
import styled from "styled-components";
import { getImage } from "@nested/utils";
import { media, SmartLink } from "@nested/ui";

const Wrapper = styled.footer`
  clear: both;
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: ${({ theme }) => theme.palette.navy.medium};
  background-image: url('${getImage("icons/map_blob.svg")}');
  background-position: bottom -350px left -250px;
  background-size: 449px 521px;
`;

const Ul = styled.ul`
  list-style-type: none;
  align-self: top;
  margin: 0px;
  padding: 0px;
  display: inline-block;
  margin-right: 50px;
  flex-shrink: 0;
  margin-bottom: 20px;
  ${media.desktop`
    margin-bottom: 0px;
  `};
`;

const Li = styled.li`
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: white;
  opacity: ${({ heading }) => (heading ? "0.5" : "1")};
  margin-bottom: 12px;
  font-weight: ${({ theme }) => theme.typography.bold};

  &:last-of-type {
    margin-bottom: 0px;
  }

  a {
    font-size: inherit;
    color: inherit;
    opacity: inherit;
    font-weight: inherit;
    text-decoration: none;
    line-height: inherit;
  }
`;

const Links = styled.div`
  display: inline-flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-shrink: 0;
`;

const Info = styled.div`
  max-width: 600px;
  margin-top: 20px;

  ${media.tablet`
    margin-top: 10px;
  `};

  ${media.desktop`
    margin-top: 0px;
  `};
`;

const Content = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  margin: auto;
  padding-left: 10px;
  padding-right: 10px;

  flex-direction: column;

  ${media.tablet`
    padding-left: 50px;
    padding-right: 50px;
  `} ${media.desktop`
    flex-direction: row;
  `};
`;

const P = styled.p`
  color: white;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.typography.light};
  line-height: 1.67;
  margin: 0px;
  padding: 0px;
  margin-bottom: 6px;

  &:last-of-type {
    margin-bottom: 0px;
  }

  a:last-of-type {
    margin-right: 0px;
  }
`;

const A = styled.a`
  font-size: 12px;
  line-height: 1.67;
  font-weight: ${({ theme }) => theme.typography.bold};
  color: white;
`;

const LinkWithSpacing = styled(A)`
  margin-right: 25px;
  display: inline-block;
`;

const Span = styled.span`
  margin-right: 20px;
  display: inline-block;
`;

const Footer = () => (
  <Wrapper>
    <Content>
      <Links>
        <Ul>
          <Li heading>Our service</Li>
          <Li>
            <SmartLink to="/how-it-works">How it works</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/customer-stories">Customer stories</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/for-sale">For sale</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/referrals">Refer a friend</SmartLink>
          </Li>
        </Ul>
        <Ul>
          <Li heading>Learn</Li>
          <Li>
            <SmartLink to="/research">Research</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/guides/sell-your-home-fast">Guides</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/property-market/london">
              Property market report
            </SmartLink>
          </Li>
          <Li>
            <a href="/performance">Performance</a>
          </Li>
          <Li>
            <a href="https://support.nested.com">FAQ</a>
          </Li>
        </Ul>
        <Ul>
          <Li heading>Company</Li>
          <Li>
            <SmartLink to="/about">About</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/careers">Careers</SmartLink>
          </Li>
          <Li>
            <SmartLink to="/press">Press</SmartLink>
          </Li>
          <Li>
            <a href="https://support.nested.com/nested-s-data-and-privacy-policy/nested-s-privacy-policy/what-data-we-collect-and-how-we-use-it">
              Privacy policy
            </a>
          </Li>
          <Li>
            <a href="http://support.nested.com/nested-s-data-and-privacy-policy/nested-s-privacy-policy/nestedcom-website-terms-and-conditions">
              Website terms and conditions
            </a>
          </Li>
        </Ul>
      </Links>
      <Info>
        <P>
          Nextday Property Ltd. trading as Nested, company registration number
          09900783.
        </P>
        <P>
          Nested is a member of{" "}
          <A href="https://www.tpos.co.uk/">The Property Ombudsman</A> and is
          authorised and regulated by the{" "}
          <A href="https://register.fca.org.uk/ShPo_FirmDetailsPage?id=001b000003aZkK2AAK">
            Financial Conduct Authority
          </A>{" "}
          (No. 766811).
        </P>
        <P>
          <Span>
            Nextday Property Ltd (trading as Nested), WeWork, 1 Waterhouse
            Square 138 Holborn London EC1N 2ST
          </Span>{" "}
          <LinkWithSpacing href="tel:+442038580695">
            020 3858 0695
          </LinkWithSpacing>{" "}
          <LinkWithSpacing href="mailto:help@nested.com">
            help@nested.com
          </LinkWithSpacing>
        </P>
        <P>
          By continuing your visit to this site, you agree to the use of
          cookies.
        </P>
      </Info>
    </Content>
  </Wrapper>
);

export default Footer;
